function addressCounty() {
  const $selects = $('select[name="address[country]"]');
  
  $selects.on('change', function() {
    const $this = $(this);
    const counties = Array($this.find('option:selected').data('provinces'))[0];
    let $province = $this.closest('form').find('select[name="address[province]"]');
    $province.empty();
    if (counties.length > 0) {
      for (let i = 0; i < counties.length; i++) {
        $province.append(`<option value="${counties[i][0]}">${counties[i][1]}</option>`)
        $province.closest('.form-row').show()
      }
    }else{
      $province.closest('.form-row').hide()
    }
  })
}

export default addressCounty();



// WEBPACK FOOTER //
// ../markup/assets/js/address-county.js